import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {RightBarSection} from '../../section/RightBarSection';
import {PredefinedTree} from './predefined-tree/PredefinedTree.component';
import {MessageForm} from './message-form/MessageForm.component';
import {MessagesList} from './messages-list/MessagesList.component';
import {SendTextDialog} from './send-text-dialog/SendTextDialog.component';
import {PredefinedTreeController} from './predefined-tree/PredefinedTree.controller';
import {MessageFormController} from './message-form/MessageForm.controller';
import {SendTextDialogController} from './send-text-dialog/SendTextDialog.controller';
import {RightBarEvents} from '../../RightBarController';
import './MessagesSection.scss';

export interface IMessagesSectionEvents {
    emit(event: RightBarEvents, ...args: any[]): void;
}

export interface IMessagesSectionController {
    readonly predefinedTreeController: PredefinedTreeController | null;
    readonly messageFormController: MessageFormController;
    readonly sendTextDialogController: SendTextDialogController;
    readonly allowMessages: boolean;
    readonly msgSectionOpen: boolean;
    readonly allowPredefined: boolean;
    readonly offlineMode: boolean;
    readonly predefinedIsEmpty: boolean;
    readonly translate: (key: string) => string;
    readonly useNewInterface: boolean;
    readonly textMessages: any[];
    readonly isAsianLanguage: boolean;
    readonly dir: 'ltr' | 'rtl';
    readonly userType: {client: string; agent: string};
    readonly observe: boolean;
    readonly isFormDisabled: boolean;
    readonly eventEmitter: IMessagesSectionEvents;
    toggleMsgSection(): void;
}

interface MessagesSectionProps {
    ctrl: IMessagesSectionController;
}

@observer
export class MessagesSection extends TechseeBaseComponent<MessagesSectionProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        if (!ctrl.allowMessages) {
            return <></>;
        }

        const showPredefined =
            ctrl.allowPredefined && !ctrl.offlineMode && ctrl.predefinedTreeController && !ctrl.predefinedIsEmpty;

        return (
            <RightBarSection
                className='messages-group'
                title={ctrl.translate('MAIN.VIEW.MESSAGES')}
                isOpen={ctrl.msgSectionOpen}
                onToggle={ctrl.toggleMsgSection}
                useNewInterface={ctrl.useNewInterface}>
                {showPredefined && (
                    <>
                        <PredefinedTree className='predefined-resources-tree' ctrl={ctrl.predefinedTreeController} />
                        <hr className='seperate-line' />
                    </>
                )}

                <MessagesList
                    messages={ctrl.textMessages}
                    isAsianLanguage={ctrl.isAsianLanguage}
                    dir={ctrl.dir}
                    UserType={ctrl.userType}
                    onClick={() => ctrl.eventEmitter.emit(RightBarEvents.OPEN_RIGHT_BAR)}
                />

                {!ctrl.observe && !ctrl.offlineMode && (
                    <MessageForm
                        controller={ctrl.messageFormController}
                        isDisabled={ctrl.isFormDisabled}
                        placeholder={ctrl.translate('MAIN.VIEW.SEND')}
                        dir={ctrl.dir}
                        onFocus={() => ctrl.eventEmitter.emit(RightBarEvents.OPEN_RIGHT_BAR, true)}
                        onBlur={() => ctrl.eventEmitter.emit(RightBarEvents.CLOSE_RIGHT_BAR, false)}
                    />
                )}
                <SendTextDialog ctrl={ctrl.sendTextDialogController} />
            </RightBarSection>
        );
    }
}
